var map = {
	"./alert-red-exclamation.png": "076e",
	"./company-green-icon.png": "5861",
	"./company-yellow-icon.png": "1514",
	"./doses-left-icon.png": "b26c",
	"./error-icon.png": "ed9f",
	"./people-blue-icon.png": "5115",
	"./people-green-icon.png": "4cb0",
	"./people-yellow-icon.png": "4443",
	"./purple-vaccine-icon.png": "5081",
	"./search.png": "c770",
	"./warn-icon.png": "cb7f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49b0";